import { useContext } from "react";
import { LandlordVerificationContext } from "./LandlordVerificationContext";

/**
 * Access the landlord verification modal. Must be used within
 * `LandlordVerificationProvider` (mounted in `LandlordLayout`).
 */
export const useLandlordVerificationModal = () => {
  const ctx = useContext(LandlordVerificationContext);
  if (!ctx) {
    throw new Error(
      "useLandlordVerificationModal must be used within a LandlordVerificationProvider",
    );
  }
  return ctx;
};
